import React from 'react';
import logo from "../Images/logo.png";

const LoaderSpiner = () => {
  const loaderContainerStyle = {
    height: '60vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  };

  const spinnerStyle = {
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    animation: 'spin 1.2s linear infinite',
  };

  const ringStyle = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    border: '6px solid transparent',
    borderTop: '6px solid #8b5cf6', // Vibrant purple
    borderRight: '6px solid #3b82f6', // Blue gradient
    borderRadius: '50%',
    animation: 'spin 1s ease-in-out infinite',
  };

  const logoStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 1000,
    width: '40px',
    height: '40px',
    animation: 'pulse 2s ease-in-out infinite',
  };

  return (
    <div style={loaderContainerStyle}>
      <img style={logoStyle} src={logo} alt="Logo" />

      <div style={spinnerStyle}>

        <div style={ringStyle}></div>
      </div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes pulse {
            0%, 100% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.2); opacity: 0.8; }
          }
        `}
      </style>
    </div>
  );
};

export default LoaderSpiner;